import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const AdminPanelSideBar = () => {
    const location = useLocation();
    let page = location.pathname.split('/admin').pop();
    const [activeSection, setActiveSection] = useState(page ? page : '');
    return (
        <>
            <div className="dashboard">
                <div className="side-nav">
                    <ul className="ul">
                        <li className={activeSection === '' && 'activeli'}><NavLink to="/admin" onClick={() => setActiveSection('')}>All Posts</NavLink></li>
                        <li className={activeSection === '/my-posts' && 'activeli'}><NavLink to="/admin/my-posts" onClick={() => setActiveSection('/my-posts')}>My Posts</NavLink></li>
                        <li className={activeSection === '/my-donations' && 'activeli'}><NavLink to="/admin/my-donations" onClick={() => setActiveSection('/my-donations')}>My Donations</NavLink></li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default AdminPanelSideBar;
